// Файл loading.js

/**
 * Общий индикатор показывает состояние ожидания без локальных spinner.
 * Компонент использует единый круговой маркер и подпись загрузки.
 * Размер выбирается параметром и не требует отдельных реализаций.
 * Дополнительный className сохраняет раскладку конкретного экрана.
 * Доступность обеспечивается ролью status и aria-подписью.
 */

import './loading.css';



const LoadingIndicator = ({
    size = 'medium',
    className = '',
    spinnerClassName = '',
    label = 'Ожидание выполнения',
    fullScreen = false,
}) => (
    <span
        className={[
            'shared-loading-indicator',
            `shared-loading-indicator--${size}`,
            fullScreen
                ? 'shared-loading-indicator--full-screen'
                : '',
            className,
        ].filter(Boolean).join(' ')}
        role="status"
        aria-label={label}
    >
        <span
            className={[
                'shared-loading-indicator__spinner',
                spinnerClassName,
            ].filter(Boolean).join(' ')}
            aria-hidden="true"
        />
        <span
            className="shared-loading-indicator__caption"
            aria-hidden="true"
        >
            Загрузка
            <span className="shared-loading-indicator__dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </span>
        </span>
    </span>
);


export default LoadingIndicator;
